import { call, put, takeLatest } from "redux-saga/effects";
import { client } from "../apollo-client";
import { GET_BRAND } from "./mutations";
import {
  fetchBrandStart,
  fetchBrandSuccess,
  fetchBrandFailure,
  fetchBrand,
} from "./reducer";
import { PayloadAction } from "@reduxjs/toolkit";

function* fetchBrandSaga(
  action: PayloadAction<{ id: string }>
): Generator<any, void, any> {
  try {
    yield put(fetchBrandStart());

    const response = yield call([client, client.query], {
      query: GET_BRAND,
      variables: {
        input: {
          id: action.payload.id,
        },
      },
    });

    if (response.data.brand) {
      yield put(fetchBrandSuccess(response.data.brand));
    } else {
      yield put(fetchBrandFailure("Brand not found"));
    }
  } catch (error) {
    console.error("Error fetching brand:", error);
    yield put(fetchBrandFailure(error.message || "Failed to fetch brand"));
  }
}

export function* brandSaga() {
  yield takeLatest(fetchBrand.type, fetchBrandSaga);
}
